module.exports = __webpack_public_path__ + "img/dan1.9252b3a8.png";